import { Box, Flex, Grid, GridItem, Image, Input, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, Tooltip, IconButton, } from '@chakra-ui/react'
import MyDiv from './leaveMaster.style';
import { CustomButton, CustomToast } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useFetch } from "../../../../hooks/useFetch";
import { ILeave } from './model';
import CustomTables, { Column, ILazyParams } from '../../../../components/CustomTable/CustomTables';
import { EditIcon } from '@chakra-ui/icons';

const LeaveMaster = () => {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [leave, setLeave] = useState<ILeave[]>([]);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentLeave, setCurrentLeave] = useState({ id: 0, leaveDays: 0, leaveType: '', });

    const [dataLoading, setDataLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0, rows: 20, sortField: undefined, sortOrder: undefined,
        multiSortMeta: [], filters: {}, globalFilter: '',
    });

    const handleAddNewLeave = () => {
        setIsEditMode(false);
        setCurrentLeave({ id: 0, leaveType: '', leaveDays: 0 });
        setDrawerOpen(true);
    };

    const handleEditLeave = (leave: ILeave) => {
        setIsEditMode(true);
        setSelectedId(leave.id);
        setCurrentLeave(leave);
        setDrawerOpen(true);
    };

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        if (name === "leaveType" && !/^[A-Za-z\s]*$/.test(value)) {
            return;
        }
        if (name === "leaveDays" && !/^\d*$/.test(value)) {
            return;
        }

        setCurrentLeave(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleSubmit = async () => {
        if (!currentLeave.leaveType.trim()) {
            addToast({ message: "Please enter leave Type", status: "warning" });
            return;
        }
        if (!currentLeave.leaveDays.toString().trim()) {
            addToast({ message: "Please enter Leave Days", status: "warning" });
            return;
        }
        if (isEditMode) {
            const response = await fetchApi<ILeave>(`Hrlense_LeaveMaster/${currentLeave.id}`, "PUT", { id: currentLeave.id, LeaveType: currentLeave.leaveType, LeaveDays: currentLeave.leaveDays, }, null, "Leave updated successfully");
            if (response) {
                await loadLeave();
            }

        } else {
            const response = await fetchApi<ILeave>("Hrlense_LeaveMaster", "POST", { LeaveType: currentLeave.leaveType, LeaveDays: currentLeave.leaveDays, }, null, "Leave added successfully");
            if (response) {
                await loadLeave();
            }
        }
        setDrawerOpen(false);
    };

    useEffect(() => {
        loadLeave();
    }, [lazyParams]);

    const loadLeave = async () => {
        setDataLoading(true);
        const params = new URLSearchParams();
        params.set('first', String(lazyParams.first));
        params.set('rows', String(lazyParams.rows));
        if (lazyParams.sortField) params.set('sortField', lazyParams.sortField);
        if (lazyParams.sortOrder) params.set('sortOrder', String(lazyParams.sortOrder));
        if (lazyParams.globalFilter) params.set('globalFilter', lazyParams.globalFilter);
        if (lazyParams.filters && Object.keys(lazyParams.filters).length) {
            params.set('filters', JSON.stringify(lazyParams.filters));
        }

        const response = await fetchApi<any>(`Hrlense_LeaveMaster?${params.toString()}`, "GET");
        if (response) {
            setLeave(response.data ?? response ?? []);
            setTotalCount(response.totalRecords ?? response.length ?? 0);
        }
        setDataLoading(false);
    };

    return (
        <MyDiv>
            <Flex className="page_heading flex_header" >
                <Text className="font-poppins text_semibold text_3xl">Leave Master</Text>
                <Flex gap={2}>
                    <CustomButton title="Add Leave" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddNewLeave} />
                </Flex>
            </Flex>
            <Grid className='grid_container'>
                <GridItem colSpan={12}>
                    <CustomTables<ILeave>
                        value={leave} loading={dataLoading} emptyMessage="No Leaves Found" preferenceKey="leaveMasterTable" showGlobalSearch={false} showToolbar={true}
                        lazy lazyParams={lazyParams} onLazyParamsChange={setLazyParams} totalRecords={totalCount} showPagination rowsPerPageOptions={[20, 100, 200, 500]}
                        maxTableHeight={null}
                    >
                        <Column header="S. No" body={(_, index) => lazyParams.first + index + 1} />
                        <Column header="Leave Type" field="leaveType" sortable filterable filterType="text" />
                        <Column header="Leave Days" field="leaveDays" sortable filterable filterType="number" />
                        <Column header="Actions" frozen="right" body={(row: any) => (
                                <Tooltip label="Edit Leave" hasArrow>
                                    <IconButton aria-label="Edit" icon={<EditIcon />} size="sm" colorScheme="orange" variant="ghost" onClick={() => handleEditLeave(row)} />
                                </Tooltip>
                            )}
                        />
                    </CustomTables>
                </GridItem>
            </Grid>

            <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Leave' : 'Add New Leave'}</DrawerHeader>
                    <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                        <Box py={4}>
                            <FormControl mb={4} isRequired>
                                <FormLabel>Leave Type</FormLabel>
                                <Input name="leaveType" value={currentLeave.leaveType} onChange={handleInputChange} placeholder="Enter leave type" />
                            </FormControl>
                            <FormControl mb={4} isRequired>
                                <FormLabel>Leave Days</FormLabel>
                                <Input name="leaveDays" value={currentLeave.leaveDays} onChange={handleInputChange} placeholder="Enter leave days" />
                            </FormControl>
                        </Box>
                        <Flex justify="flex-end" mt={4} gap={2}>
                            <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
                            <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>{isEditMode ? "Update Leave" : "Add Leave"}</Button>
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </MyDiv>
    )
}

export default LeaveMaster;